<script>
    import { onMount } from "svelte";

    import Gallery from "./gallery.js";
    import { debug } from "svelte/internal";

    import {
        degrees_to_rad,
        rad_to_degrees,
        calculate_zoom_after_rotation,
        dataURLToFileImage,
    } from "./functions.js";

    let myGallery = new Gallery();

    export let fileInput;

    var is_mobile = false;
    if (window.innerWidth < 768) {
        is_mobile = true;
    } else {
    }
    var image = new Image();

    var canvas = null;
    var ctx = null;

    var debug_ = false;

    var tutorial = true;
    if (import.meta.url.indexOf("localhost") != -1) {
        debug_ = true;
    }
    if (!debug_) {
        console.log = function () {};
        console.warn = function () {};
        console.error = function () {};
    }

    /*
    function reset_all_rotations() {
        for (i = 0; i < myGallery.images; i++) {
            myGallery.images[i].rotation = 0;
            myGallery.images[i].image_rotated = false;
        }
        myGallery = myGallery;
        image.onload();
    }
    */
    /*
    function dropped_files(event) {
        console.log(event);
        let files = event.dataTransfer.files;
        files = Array.from(files).filter((file) =>
            file.type.startsWith("image/")
        );
        console.log(files);
        gallery_add_files(files);
    }
    */

    async function load_demo_tutorial() {
        var url_img = "./img/img-demo-correct-arrows.jpg";

        var blob = false;

        try {
            var resp = await fetch(url_img);
            if (!resp.ok) {
                throw new Error("Failed to fetch image");
            }
            blob = await resp.blob();
            if (!blob) {
                return false;
            }
        } catch (error) {
            console.error("Error loading image:", error);
            return false;
        }
        const file = new File([blob], "img-demo-correct.jpg", {
            type: "image/jpeg",
        });

        tutorial = true;

        gallery_add_files([file], function () {
            galeria_imagen_click(myGallery.images.length - 1); // no, la ultima imagen añadida
        });
    }

    function reset_current_rotation(event) {
        if (myGallery.getSelectedImage())
            myGallery.updateSelectedImageProperty("rotation", 0);
        myGallery.updateSelectedImageProperty("image_rotated", false);
        //redraw canvas
        myGallery = myGallery;

        // canvas.dispatchEvent(new Event('mousemove'));
        image.onload();
    }

    function galeria_imagen_borrar(i) {
        console.log("Image index clicked to delete:", i);
        // la que borramos es la que está ahora??

        myGallery.removeImage(i);
        if (myGallery.getSelectedImageIndex() === i) {
            if (!myGallery.images.length) galeria_imagen_click(-1);
            else if (i != 0) galeria_imagen_click(0);
            else galeria_imagen_click(1);
        }
        myGallery = myGallery; // para que la referencia se actualice y dispare reactividad

        if (!myGallery.images.length) {
            var tooltips = document.querySelectorAll(".tooltip");
            if (tooltips) {
                for (var t of tooltips) {
                    t.remove();
                }
            }
        }
    }

    function galeria_imagen_click(i) {
        console.log("Image index clicked:", i);
        if (i < 0) {
            myGallery.clearSelectedImage();
            image.src = "";
            return false;
        }
        myGallery.setSelectedImage(i);
        if (myGallery.getSelectedImage()) {
            image.src = myGallery.getSelectedImage().image.src; // se hace  image.onload = function ()  ...
        }
        //  window.image_current_name = file.name;
        myGallery = myGallery;
        window.modal.show();

        return false;
    }

    function gallery_add_files(files, callback) {
        //if(!canvas) canvas_init();

        // depends on myGallery,
        for (var i = 0; i < files.length; i++) {
            var file = files[i];

            // Verify if the file is an image
            if (file && file.type.startsWith("image/")) {
                var reader = new FileReader();
                reader.onload = (function (file, i) {
                    return function (e) {
                        var image_g = new Image();
                        image_g.src = e.target.result;
                        var ext_mime = file.type.split("/")[1];
                        image_g.onload = function () {
                            myGallery.addImage({
                                filename: file.name,
                                file: file, // file object
                                image: image_g, // image object
                                image_rotated: false,
                                checked: false,
                                rotation: 0,
                                canvas_rotated: 0,
                                mime_type: file.type, //'image/'+ext_mime
                            });
                            myGallery = myGallery; // para que la referencia se actualice y dispare reactividad
                            if (i + 1 == files.length) {
                                //console.log("CARGANDO FOTO ", i);
                                if (callback) callback();
                            }

                            // debugger;
                        };
                    };
                })(file, i);
                reader.readAsDataURL(file);
            } else {
                alert("Please select image files only.");
            }
        }
    }

    function delete_all() {
        // depends on myGallery

        var only_checked = false;
        console.log("Deleting all (or checked)");
        if (myGallery.imagesIndexesWithPropertyTrue("checked").length) {
            only_checked = true;
        }

        for (var i = myGallery.images.length - 1; i >= 0; i--) {
            if (
                !only_checked ||
                (only_checked && myGallery.images[i].checked)
            ) {
                galeria_imagen_borrar(i);
            }
        }
    }

    function rotate_all_canvas(direction) {
        var new_rotation = 0,
            correction_rad = 0;

        var only_checked = false;

        if (myGallery.imagesIndexesWithPropertyTrue("checked").length) {
            only_checked = true;
        }

        // solo los seleccionados
        for (var i = 0; i < myGallery.images.length; i++) {
            if (
                !only_checked ||
                (only_checked && myGallery.images[i].checked)
            ) {
                rotate_image_canvas(i, direction);

                if (myGallery.images[i].rotation != 0) {
                    // hay que actualizar el img también si tiene rotación manual
                }
            }
        }

        // galeria_imagen_click(myGallery.getSelectedImageIndex());
    }

    function rotate_image_canvas(image_index, direction) {
        // depends on myGallery,canvas,context
        // Lets rotate {90,-90} and then apply manual rotation

        ctx.restore();
        if (direction == "right") {
            myGallery.images[image_index].canvas_rotated += 90;
        } else {
            myGallery.images[image_index].canvas_rotated -= 90;
        }

        // reseteamos rotación
        if (
            myGallery.images[image_index].canvas_rotated >= 360 ||
            myGallery.images[image_index].canvas_rotated <= -360
        )
            myGallery.images[image_index].canvas_rotated = 0;

        const canvas2 = document.createElement("canvas");
        const ctx2 = canvas2.getContext("2d");

        ctx2.save();
        // document.getElementsByTagName("body")[0].append(canvas2);
        canvas2.width = myGallery.images[image_index].image.height;
        canvas2.height = myGallery.images[image_index].image.width;
        display_origin(ctx2, "ORIG");

        // esta es una alternativa
        var nueva_rotacion = 0;
        if (direction == "right") {
            nueva_rotacion = 90; // debe ser respecto al original. Pero esa información se pierde?
        } else {
            nueva_rotacion = 360 - 90;
        }

        ////////////// OOK
        ctx2.translate(canvas2.width / 2, canvas2.height / 2);
        ctx2.rotate((nueva_rotacion * Math.PI) / 180);
        ctx2.translate(-canvas2.height / 2, -canvas2.width / 2);

        //ctx2.drawImage(image, 0, 0, canvas2.height, canvas2.width); // estamos cogiendo la imagen que tenemos del canvas. Coger la del archivo de la galeria
        var image2 = new Image();
        image2.src = myGallery.images[image_index].image.src;
        ctx2.drawImage(image2, 0, 0, canvas2.height, canvas2.width);

        ////////////// OOK

        display_origin(ctx2, "AFTER DRAW");
        //const dataURL = canvas.toDataURL('image/png'); // You can specify the image format (e.g., 'image/jpeg', 'image/png')
        var type_mime = myGallery.images[image_index].mime_type;
        var filename = myGallery.images[image_index].filename;
        const dataURL = canvas2.toDataURL(type_mime); // You can specify the image format (e.g., 'image/jpeg', 'image/png')

        var file = dataURLToFileImage(dataURL, filename, type_mime);
        //cambiar file y recargar imagen
        myGallery.images[image_index].file = file;

        var image_g = new Image();
        myGallery.images[image_index].image = image_g;
        // actualiar image_rotated ....
        // añadimos la rotación manual
        image_g.onload = function () {
            myGallery.images[image_index].image = image_g;
            // apply manual rotation for the minuature
            if (myGallery.images[image_index].rotation != 0) {
                // https://jsfiddle.net/m1erickson/92y83ybu/

                ctx2.resetTransform();
                ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
                ctx2.fillStyle = "white";
                ctx2.fillRect(0, 0, canvas2.width, canvas2.height);

                var zoom = 1;
                var correction_rad = 0;

                ctx2.translate(canvas2.width / 2, canvas2.height / 2);

                correction_rad = myGallery.images[image_index].rotation;
                ctx2.rotate(correction_rad);

                zoom = calculate_zoom_after_rotation(
                    correction_rad,
                    canvas2.width,
                    canvas2.height,
                    true,
                );

                //    ctx2.translate(canvas2.width / 2, canvas2.height / 2);
                //  display_origin(ctx2); //9
                var zoomLevel = zoom; // what zoom should be
                //       ctx2.translate(canvas2.width / 2, canvas2.height / 2);
                ctx2.scale(zoomLevel, zoomLevel); //
                //       ctx2.translate(-(canvas2.width / 2), -(canvas2.height / 2));
                //display_origin(ctx2); //10
                //ctx2.translate(-canvas2.width / 2, -canvas2.height / 2); // Translate back to the top-left corner

                ctx2.drawImage(
                    image_g,
                    -(canvas2.width / 2),
                    -(canvas2.height / 2),
                );
                //ctx2.drawImage(image_g, 0, 0);

                // para que el thumbnail se vea rotado también
                var new_img = new Image();
                new_img.src = canvas2.toDataURL("image/jpeg");
                myGallery.images[image_index].image_rotated = new_img;
                console.log("----- img rotated ----");
                console.log(new_img);

                //  document.getElementsByTagName("body")[0].append(image_g);
                //document.getElementsByTagName("body")[0].append(canvas2);
                // document.getElementsByTagName("body")[0].append(new_img);
            }
            myGallery = myGallery;
        };
        image_g.src = dataURL; //file;

        myGallery = myGallery;
        return {
            image: image_g,
            src: dataURL,
        };
    }

    function rotate_current_canvas(direction) {
        // depends on myGallery,canvas,context
        rotate_image_canvas(myGallery.getSelectedImageIndex(), direction);
        // y si esto después?
        galeria_imagen_click(myGallery.getSelectedImageIndex());
        //image.onload();

        setTimeout(function () {
            // cambiar la miniatura
            var new_img = new Image();
            new_img.src = canvas.toDataURL("image/jpeg");
            myGallery.updateSelectedImageProperty("image_rotated", new_img);
            myGallery.images[myGallery.getSelectedImageIndex()].image_rotated =
                new_img;
            // const imageElement = document.getElementById("myImage");
            // imageElement.src = canvas.toDataURL("image/jpeg");

            // image.src = myGallery.getSelectedImage().image.src;
            myGallery = myGallery;
        }, 500);
        return;
    }

    function galeria_imagen_download(i) {
        console.log("Image index clicked to download:", i);
        // la que borramos es la que está ahora??

        var img = myGallery.images[i];
        download_current_rotated_image(i);
    }
    async function img_full_of_rotated_image(index) {
        if (myGallery.getSelectedImageIndex() === false && index === false) {
            console.log("no current uimage. index= " + index);
            return false;
        }
        if (index === false) {
            var gallery_image = myGallery.getSelectedImage();
        } else {
            var gallery_image = myGallery.getImage(index);
        }

        const canvas2 = document.createElement("canvas");
        const ctx2 = canvas2.getContext("2d");

        canvas2.width = gallery_image.image.width;
        canvas2.height = gallery_image.image.height;

        // calcular rotation y zoom

        ctx2.save();
        var correction_rad = gallery_image.rotation;
        ctx2.translate(canvas2.width / 2, canvas2.height / 2);
        ctx2.rotate(correction_rad);
        ctx2.translate(-(canvas2.width / 2), -(canvas2.height / 2)); //let's translate
        var zoom = calculate_zoom_after_rotation(
            correction_rad,
            canvas2.width,
            canvas2.height,
            true,
        );
        ctx2.translate(canvas2.width / 2, canvas2.height / 2);
        var zoomLevel = zoom; // what zoom should be
        ctx2.scale(zoomLevel, zoomLevel); //
        ctx2.translate(-canvas2.width / 2, -canvas2.height / 2); // Translate back to the top-left corner

        /////////////////////////////

        ctx2.drawImage(gallery_image.image, 0, 0);
        ctx2.restore();

        var dataURL = canvas2.toDataURL("image/jpeg");

        return dataURL;
    }
    async function download_current_rotated_image(index) {
        if(typeof index==='undefined') index = false;
        if (myGallery.getSelectedImageIndex() === false &&  index === false) {
            console.log("no current uimage. index= " + index);
            return false;
        }
        var gallery_image = false;
        if (index === false) {
            gallery_image = myGallery.getSelectedImage();
        } else {
            gallery_image = myGallery.getImage(index);
        }

        const canvas2 = document.createElement("canvas");
        const ctx2 = canvas2.getContext("2d");

        canvas2.width = gallery_image.image.width;
        canvas2.height = gallery_image.image.height;

        // calcular rotation y zoom

        ctx2.save();
        var correction_rad = gallery_image.rotation;
        ctx2.translate(canvas2.width / 2, canvas2.height / 2);
        ctx2.rotate(correction_rad);
        ctx2.translate(-(canvas2.width / 2), -(canvas2.height / 2)); //let's translate
        var zoom = calculate_zoom_after_rotation(
            correction_rad,
            canvas2.width,
            canvas2.height,
            true,
        );
        ctx2.translate(canvas2.width / 2, canvas2.height / 2);
        var zoomLevel = zoom; // what zoom should be
        ctx2.scale(zoomLevel, zoomLevel); //
        ctx2.translate(-canvas2.width / 2, -canvas2.height / 2); // Translate back to the top-left corner

        /////////////////////////////

        ctx2.drawImage(gallery_image.image, 0, 0);
        ctx2.restore();

        var dataURL = canvas2.toDataURL("image/jpeg");
        const link = document.createElement("a");
        // Set the href attribute of the link to the canvas image data URL
        link.href = dataURL;

        const filename = gallery_image.filename;
        const dotIndex = filename.lastIndexOf(".");
        const name = filename.substring(0, dotIndex);
        const ext = filename.substring(dotIndex + 1);

        // Set the download attribute of the link to specify the file name
        link.download = "" + name + "_rotated." + ext;
        // Simulate a click event on the link to trigger the download
        link.click();
        return true;
    }

    async function download_rotated_images() {
        // depends on myGallery,canvas,context
        // Iterate over the images array and add each image to the zip

        var context = ctx;
        //const container = document.getElementById('test'); // Replace 'container' with the ID of your container element
        //container.appendChild(canvas);
        var make_zip = true;
        var zip = null;
        if (make_zip) {
            zip = new JSZip();
        }
        for (var i = 0; i < myGallery.images.length; i++) {
            var gallery_image = myGallery.images[i];
            canvas.width = gallery_image.image.width;
            canvas.height = gallery_image.image.height;

            // calcular rotation y zoom

            context.save();
            var correction_rad = gallery_image.rotation;
            context.translate(canvas.width / 2, canvas.height / 2);
            context.rotate(correction_rad);
            context.translate(-(canvas.width / 2), -(canvas.height / 2)); //let's translate
            var zoom = calculate_zoom_after_rotation(
                correction_rad,
                canvas.width,
                canvas.height,
                true,
            );
            context.translate(canvas.width / 2, canvas.height / 2);
            var zoomLevel = zoom; // what zoom should be
            context.scale(zoomLevel, zoomLevel); //
            context.translate(-canvas.width / 2, -canvas.height / 2); // Translate back to the top-left corner

            /////////////////////////////

            context.drawImage(gallery_image.image, 0, 0);
            context.restore();

            const filename = gallery_image.filename;
            const dotIndex = filename.lastIndexOf(".");
            const name = filename.substring(0, dotIndex);
            const ext = filename.substring(dotIndex + 1);

            if (make_zip) {
                var quality = 0.8;
                const blob = await new Promise((resolve) =>
                    canvas.toBlob(resolve, "image/jpeg", quality),
                );
                const file = new File(
                    [blob],
                    //"rotated_" + gallery_image.filename,
                    "" + name + "_rotated." + ext,
                    {
                        type: "image/jpeg",
                    },
                );
                //zip.file("rotated_" + gallery_image.filename, file);
                zip.file("" + name + "_rotated." + ext, file);
            } else {
                var dataURL = canvas.toDataURL("image/jpeg");
                const link = document.createElement("a");
                // Set the href attribute of the link to the canvas image data URL
                link.href = dataURL;

                // Set the download attribute of the link to specify the file name
                // Set the download attribute of the link to specify the file name
                //link.download = "rotated_" + gallery_image.filename;
                link.download = "" + name + "_rotated." + ext;

                // Simulate a click event on the link to trigger the download
                link.click();
                //zip.file('image' + i + '.jpg', dataURL.substr(dataURL.indexOf(',') + 1), { base64: true });
            }
        }
        if (make_zip) {
            var content = await zip.generateAsync({ type: "base64" });

            const link = document.createElement("a");
            link.href = "data:application/zip;base64," + content;
            link.download = "rotated_images.zip";

            // Trigger the download
            link.click();
        }

        // restaurar canvas

        //galeria_imagen_click(myGallery.getSelectedImageIndex);
        return true;
    }

    async function copyCanvasToClipboard(canvas) {
        canvas.toBlob(async (blob) => {
            const item = new ClipboardItem({ [blob.type]: blob });
            await navigator.clipboard.write([item]);
            console.log("Canvas image copied!");
        });
    }

    /*
    async function copyImageElementToClipboard(img) {
        console.log('copying image to clipboard')
        console.log(img)
        const response = await fetch(img.src);
        const blob = await response.blob();

        const item = new ClipboardItem({ [blob.type]: blob });
        await navigator.clipboard.write([item]);
    }
    */

    async function copyImageElementToClipboard(img) {
        console.log("copying image to clipboard");

        // Load image into an HTMLImageElement (to ensure CORS-safe)
        const response = await fetch(img.src);
        const blob = await response.blob();

        // Draw image onto canvas
        const bitmap = await createImageBitmap(blob);
        const canvas = document.createElement("canvas");
        canvas.width = bitmap.width;
        canvas.height = bitmap.height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(bitmap, 0, 0);

        // Convert canvas to PNG blob
        const pngBlob = await new Promise((resolve) =>
            canvas.toBlob(resolve, "image/png"),
        );

        // Write PNG blob to clipboard
        const item = new ClipboardItem({ "image/png": pngBlob });
        await navigator.clipboard.write([item]);

        console.log("Copied as PNG!");
    }

    var displayWidth = 0;
    var displayHeight = 0;

    var modal = null;

    onMount(() => {
        if (
            displayMode == "standalone" &&
            navigator.userAgent.toLowerCase().indexOf("android") > -1
        ) {
            document.querySelectorAll(".installed_hide").forEach((el) => {
                el.style.display = "none";
            });
        } else if (displayMode == "browser") {
            //jQuery('.install_suggest').show();
        } else if (displayMode != "browser") {
            //jQuery('.install_suggest').remove();
            document.querySelectorAll(".installed_hide").forEach((el) => {
                el.style.display = "none";
            });
        }

        worker_install();

        window.modal = new bootstrap.Modal(
            document.getElementById("modal_canvas"),
            {},
        );

        document
            .getElementById("modal_canvas")
            .addEventListener("hidden.bs.modal", (event) => {
                // do something...
                console.log("modal closed");
                myGallery.setSelectedImage(false);
                myGallery = myGallery;
            });

        document.addEventListener("keydown", function (event) {
            // Check if the pressed key is the right arrow key (keyCode 39)

            //primero saber si hemos abierto una
            var index = myGallery.getSelectedImageIndex();
            if (index === false) {
                return;
            }

            //window.modal.hide();
            console.log("index:::::::::" + index);
            index = parseInt(index);

            if (event.keyCode === 39) {
                // Right arrow key is pressed
                console.log("Right arrow key pressed");
                // Add your right arrow key handling code here
                if (index + 1 < myGallery.images.length)
                    galeria_imagen_click(index + 1);
            }
            // Check if the pressed key is the left arrow key (keyCode 37)
            else if (event.keyCode === 37) {
                // Left arrow key is pressed
                console.log("Left arrow key pressed");
                // Add your left arrow key handling code here
                if (index - 1 >= 0) galeria_imagen_click(index - 1);
            }
        });

        function isImageURL(text) {
            try {
                const url = new URL(text);
                return /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(url.pathname);
            } catch {
                return false;
            }
        }

        async function downloadImageFromURL(url) {
            try {
                const res = await fetch(url);
                const blob = await res.blob();

                const ext = blob.type.split("/")[1];
                const filename = "pasted_image." + ext;

                return new File([blob], filename, { type: blob.type });
            } catch (err) {
                console.error("Failed to download image:", err);
                return null;
            }
        }

        window.addEventListener("paste", async (event) => {
            const items = event.clipboardData.items;
            const clipboard = event.clipboardData;
            var imgs = [];
            for (const item of items) {
                if (item.type.startsWith("image/")) {
                    const file = item.getAsFile();
                    imgs.push(file);
                    // Now you can load it into your gallery
                }
            }
            if (imgs.length) {
                gallery_add_files(imgs);
                return;
            }

            const text = clipboard.getData("text");
            if (isImageURL(text)) {
                const file = await downloadImageFromURL(text);
                if (file) addImageToGallery(file);
            }
        });

        fileInput = document.getElementById("files_picker");
        var gallery = document.getElementById("gallery");

        // Get the canvas element and its context

        var currentMousePosition = { x: 0, y: 0 };

        // Create an image object

        // Set the source of the image
        //  image.src = "imgs_corregir/apartamento-cullera-primera-linea-playa-96-other.jpg";

        var clickedCoordinates = [];
        var show_smaller = true;

        var images_loaded = [];
        var image_current_name = "";

        //download_imagesBtn.addEventListener("click", function () {

        fileInput.addEventListener("change", function (event) {
            console.log("input changed");
            var files = event.target.files;
            if (tutorial) {
                // borrar imagenes tutorial si las hay
                if (myGallery.images.length == 1) myGallery.removeImage(0);
            }
            tutorial = false;
            gallery_add_files(files);
        });

        // Wait for the image to load: the main image that will be loaded on canvas
        image.onload = function () {
            // Set the canvas size to match the image

            if (!canvas) canvas_init();

            clickedCoordinates = [];

            if (canvas.cb_click)
                canvas.removeEventListener("click", canvas.cb_click, false);
            if (canvas.cb_mousemove)
                canvas.removeEventListener(
                    "mouse_move",
                    canvas.cb_mousemove,
                    false,
                );

            var scaleX = 1;
            var scaleY = 1;
            displayWidth = image.width;
            displayHeight = image.height;

            if (show_smaller) {
                //calcular e constraint

                displayWidth = 600; // Adjust as needed
                displayHeight = (displayWidth * image.height) / image.width;

                window.innerHeight;
                window.innerWidth;

                var porcentaje_margen = 0.75;

                var ratio_width = window.innerWidth / image.width;
                var ratio_height = window.innerHeight / image.height;

                if (ratio_width < ratio_height) {
                    console.log("Ratio width menor .... kets vase ib wudtg");
                    displayWidth = Math.floor(image.width * ratio_width);
                    displayHeight = (displayWidth * image.height) / image.width;
                } else {
                    console.log("Ratio width mayor.... lets base on height");
                    displayHeight = Math.floor(image.height * ratio_height);
                    displayWidth = (displayHeight * image.width) / image.height;
                }
                displayWidth *= porcentaje_margen;
                displayHeight *= porcentaje_margen;
                displayWidth = Math.floor(displayWidth);
                displayHeight = Math.floor(displayHeight);

                canvas.width = displayWidth;
                canvas.height = displayHeight;

                //console.log("image loaded dimensions");
                //console.log("displayWidth: ", displayWidth);
                //console.log("displayHeight: ", displayHeight);
                //console.log("canvas.width: ", canvas.width);
                //console.log("canvas.height: ", canvas.height);

                console.log("---------------------------");
            }

            //ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            ctx.save();

            ////////////////////////
            ////////////// TEST PREDEFINED ROTATION
            //myGallery.updateSelectedImageProperty('rotation', Math.PI / 4)
            ///////////////////////

            var has_rotation = false;
            if (
                myGallery.getSelectedImage() &&
                myGallery.getSelectedImage().rotation
            ) {
                console.log(
                    "HASSSSSSSSSSSSS ROTATION OF ",
                    myGallery.getSelectedImage().rotation,
                );

                var correction_rad = myGallery.getSelectedImage().rotation;

                has_rotation = correction_rad;

                display_origin(ctx);
                ctx.translate(canvas.width / 2, canvas.height / 2);
                ctx.rotate(correction_rad);
                ctx.translate(-(canvas.width / 2), -(canvas.height / 2)); //let's translate
                display_origin(ctx);

                var zoom = calculate_zoom_after_rotation(
                    correction_rad,
                    displayWidth,
                    displayHeight,
                    true,
                );

                ctx.translate(canvas.width / 2, canvas.height / 2);
                var zoomLevel = zoom; // what zoom should be
                ctx.scale(zoomLevel, zoomLevel); //
                ctx.translate(-canvas.width / 2, -canvas.height / 2); // Translate back to the top-left corner
            } else if (!myGallery.getSelectedImage()) {
                canvas.width = 0;
                canvas.height = 0;
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                return false;
            }

            display_origin(ctx);

            if (show_smaller) {
                var origin_moved_x = canvas.width / 2 - displayWidth / 2;
                var origin_moved_y = canvas.height / 2 - displayHeight / 2;

                // Set the canvas size to match the display size

                // displayWidth = 600; // Adjust as needed
                // displayHeight = (displayWidth * image.height) / image.width;

                // canvas.width = displayWidth;
                // canvas.height = displayHeight;

                console.log("smaller drawing");

                ctx.drawImage(image, 0, 0, displayWidth, displayHeight);

                scaleX = image.width / displayWidth;
                scaleY = image.height / displayHeight;
            } else {
                canvas.width = image.width;
                canvas.height = image.height;
                ctx.drawImage(image, 0, 0);
            }

            display_origin(ctx);

            ctx.restore();

            // Draw the image on the canvas

            var canvas_mousedown = false;
            canvas.addEventListener(
                "mouseup",
                (canvas.cb_mouseup = function (event) {
                    canvas_mousedown = false;
                    if (clickedCoordinates.length == 1) {
                        //  clickedCoordinates = [];
                    }
                }),
            );

            canvas.addEventListener(
                "mousedown",
                (canvas.cb_mousedown = function (event) {
                    // Get the coordinates of the clicked pixel
                    console.log("CANVAS mousedown");
                    var x = 0;
                    var y = 0;
                    var rect = canvas.getBoundingClientRect();
                    var x_not_scaled = event.clientX - rect.left;
                    var y_not_scaled = event.clientY - rect.top;
                    if (show_smaller) {
                        var scaleX = image.width / displayWidth;
                        var scaleY = image.height / displayHeight;
                        x = Math.floor((event.clientX - rect.left) * scaleX);
                        y = Math.floor((event.clientY - rect.top) * scaleY);
                    } else {
                        x = event.clientX - rect.left;
                        y = event.clientY - rect.top;
                    }

                    canvas_mousedown = true;

                    if (!clickedCoordinates.length) {
                        // iniciamos dragging también
                        clickedCoordinates.push({ x: x, y: y });

                        const radius = 10; // Radius of the circle
                        const fillColor = "red"; // Fill color of the circle

                        if (is_mobile) {
                            // Draw the circle
                            ctx.beginPath();
                            ctx.arc(
                                x_not_scaled,
                                y_not_scaled,
                                radius,
                                0,
                                2 * Math.PI,
                            ); // Draws a full circle
                            ctx.fillStyle = fillColor;
                            ctx.fill();
                            ctx.closePath();
                        }
                    }
                }),
            );

            // Add a click event listener to the canvas
            canvas.addEventListener(
                "click",
                (canvas.cb_click = function (event) {
                    // Get the coordinates of the clicked pixel
                    console.log("CANVAS CLICKED");
                    var x = 0;
                    var y = 0;

                    if (show_smaller) {
                        var rect = canvas.getBoundingClientRect();
                        var scaleX = image.width / displayWidth;
                        var scaleY = image.height / displayHeight;
                        x = Math.floor((event.clientX - rect.left) * scaleX);
                        y = Math.floor((event.clientY - rect.top) * scaleY);
                    } else {
                        var rect = canvas.getBoundingClientRect();
                        x = event.clientX - rect.left;
                        y = event.clientY - rect.top;
                    }
                    // Display the coordinates
                    //alert("Clicked pixel coordinates: (" + x + ", " + y + ")");

                    clickedCoordinates.push({ x: x, y: y });

                    if (clickedCoordinates.length == 1) {
                        // pintar una cruz, para el movil al menos
                    }
                    if (clickedCoordinates.length == 2) {
                        //calcular la distancia con el primer punto
                        // si es mínima, es que ha hecho click y no estaba haciendo
                        // dragging
                        var lastClickedX = clickedCoordinates[0].x;
                        var lastClickedY = clickedCoordinates[0].y;
                        var ancho = x - lastClickedX;
                        var alto = y - lastClickedY;
                        var hipotenusa = Math.sqrt(ancho ** 2 + alto ** 2);
                        if (hipotenusa < 10) {
                            clickedCoordinates.splice(1, 1);
                            console.log("no click. dragging");
                        }
                    }

                    if (clickedCoordinates.length == 2) {
                        var lastClickedX =
                            clickedCoordinates[clickedCoordinates.length - 2].x;
                        var lastClickedY =
                            clickedCoordinates[clickedCoordinates.length - 2].y;

                        var ancho = x - lastClickedX;
                        var alto = y - lastClickedY;
                        var hipotenusa = Math.sqrt(ancho ** 2 + alto ** 2);
                        var angulo = rad_to_degrees(Math.atan2(alto, ancho));

                        if (angulo < 0) {
                            angulo += 360; // Convert negative angles to positive
                        }

                        console.log(clickedCoordinates);
                        console.log("angulooooooooooooo " + angulo);

                        ctx.save();

                        ctx.clearRect(0, 0, canvas.width, canvas.height);

                        // Save the current context state

                        var rotationAngle = degrees_to_rad(angulo);

                        console.log(
                            "rotation angle =",
                            angulo,
                            " ---------RAD=",
                            rotationAngle,
                        );
                        // var centerX = (canvas.width / 2) / scaleX;
                        // var centerY = (canvas.height / 2) / scaleY;
                        //
                        // Apply transformations (scale, translate, rotate)
                        //  ctx.translate(centerX, centerY);

                        //  ctx.scale(scaleX, scaleY);

                        var threshold_degrees = 45;
                        var correction = 0;
                        if (angulo < threshold_degrees) {
                            correction = -angulo;
                        } else if (angulo < 90) {
                            correction = 90 - angulo;
                        } else if (angulo < 90 + threshold_degrees) {
                            correction = -(angulo - 90);
                        } else if (angulo < 180) {
                            correction = 180 - angulo;
                        } else if (angulo < 180 + threshold_degrees) {
                            correction = -(angulo - 180);
                        } else if (angulo < 270) {
                            correction = 270 - angulo;
                        } else if (angulo < 270 + threshold_degrees) {
                            correction = -(angulo - 270);
                        } else if (angulo < 360) {
                            correction = 360 - angulo;
                        } else {
                            // no rotation
                            console.log("NO ROTATION");
                            return;
                        }

                        // Draw the image (assuming you have loaded it)

                        var current_rotation =
                            myGallery.getSelectedImage().rotation;

                        ctx.translate(canvas.width / 2, canvas.height / 2);
                        correction_rad = degrees_to_rad(correction);

                        correction_rad += current_rotation;

                        ctx.rotate(correction_rad);
                        ctx.translate(
                            -(canvas.width / 2),
                            -(canvas.height / 2),
                        ); //let's translate

                        //images_loaded[get_image_index(image_current_name)].rotation = correction_rad;

                        myGallery.updateSelectedImageProperty(
                            "rotation",
                            correction_rad,
                        );

                        zoom = calculate_zoom_after_rotation(
                            correction_rad,
                            displayWidth,
                            displayHeight,
                            true,
                        );

                        var centerX = canvas.width / 2; // Center X coordinate of the canvas
                        var centerY = canvas.height / 2; // Center Y coordinate of the canvas
                        ctx.translate(centerX, centerY);
                        zoomLevel = zoom; // what zoom should be
                        ctx.scale(zoomLevel, zoomLevel); //
                        ctx.translate(-centerX, -centerY); // Translate back to the top-left corner

                        origin_moved_x = canvas.width / 2 - displayWidth / 2;
                        origin_moved_y = canvas.height / 2 - displayHeight / 2;

                        //ctx.drawImage(image, 300,0, displayWidth, displayHeight);
                        ctx.drawImage(
                            image,
                            origin_moved_x,
                            origin_moved_y,
                            displayWidth,
                            displayHeight,
                        ); //draw the image ;)

                        // ctx.drawImage(image, displayWidth, displayHeight);

                        // Restore the context state
                        ctx.restore();
                        var new_img = new Image();
                        new_img.src = canvas.toDataURL("image/jpeg");
                        myGallery.updateSelectedImageProperty(
                            "image_rotated",
                            new_img,
                        );
                        myGallery = myGallery;
                        clickedCoordinates = []; // reset

                        return;
                    }

                    if (clickedCoordinates.length == 3) {
                        clickedCoordinates = [];
                        // restore image ???

                        // drawLinesPath();

                        return;
                    }
                }),
            );

            // Add a mousemove event listener to the canvas
            canvas.addEventListener(
                "mousemove",
                (canvas.cb_mousemove = function (event) {
                    // Get the coordinates of the mouse position

                    if (clickedCoordinates.length < 1) return;

                    if (clickedCoordinates.length == 2) {
                        // no pintar
                        //  clickedCoordinates.splice(0, 1)
                        return;
                    }

                    var x = 0;
                    var y = 0;

                    if (show_smaller) {
                        var rect = canvas.getBoundingClientRect();
                        var scaleX = image.width / displayWidth;
                        var scaleY = image.height / displayHeight;
                        x = Math.floor((event.clientX - rect.left) * scaleX);
                        y = Math.floor((event.clientY - rect.top) * scaleY);
                    } else {
                        var rect = canvas.getBoundingClientRect();
                        x = event.clientX - rect.left;
                        y = event.clientY - rect.top;
                    }

                    // Draw a line from the last clicked point to the current mouse position

                    if (clickedCoordinates.length >= 1) {
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        var current_rotation =
                            myGallery.getSelectedImage().rotation;

                        if (current_rotation) {
                            ctx.save();

                            ctx.translate(canvas.width / 2, canvas.height / 2);
                            ctx.rotate(correction_rad);
                            ctx.translate(
                                -(canvas.width / 2),
                                -(canvas.height / 2),
                            ); //let's translate

                            var zoom = calculate_zoom_after_rotation(
                                current_rotation,
                                displayWidth,
                                displayHeight,
                                true,
                            );
                            ctx.translate(canvas.width / 2, canvas.height / 2);
                            zoomLevel = zoom; // what zoom should be
                            ctx.scale(zoomLevel, zoomLevel); //
                            ctx.translate(
                                -canvas.width / 2,
                                -canvas.height / 2,
                            ); // Translate back to the top-left corner

                            ctx.restore();
                        }
                        console.log(
                            " drawLines drawLines drawLines. current_rotation: ",
                            current_rotation,
                        );

                        ctx.save();
                        /* Apply rotation and zooming */
                        ctx.translate(canvas.width / 2, canvas.height / 2);
                        ctx.rotate(correction_rad);
                        ctx.translate(
                            -(canvas.width / 2),
                            -(canvas.height / 2),
                        ); //let's translate
                        var zoom = calculate_zoom_after_rotation(
                            correction_rad,
                            displayWidth,
                            displayHeight,
                            true,
                        );
                        ctx.translate(canvas.width / 2, canvas.height / 2);
                        zoomLevel = zoom; // what zoom should be
                        ctx.scale(zoomLevel, zoomLevel); //
                        ctx.translate(-canvas.width / 2, -canvas.height / 2); // Translate back to the top-left corner

                        ctx.drawImage(image, 0, 0, displayWidth, displayHeight);
                        ctx.restore();

                        var rect = canvas.getBoundingClientRect();
                        currentMousePosition.x = Math.floor(
                            (event.clientX - rect.left) * scaleX,
                        );
                        currentMousePosition.y = Math.floor(
                            (event.clientY - rect.top) * scaleY,
                        );
                        var angle =
                            Math.atan2(
                                currentMousePosition.y,
                                currentMousePosition.x,
                            ) *
                            (180 / Math.PI);
                        var ancho =
                            currentMousePosition.x -
                            clickedCoordinates[clickedCoordinates.length - 1].x;
                        var alto =
                            currentMousePosition.y -
                            clickedCoordinates[clickedCoordinates.length - 1].y;

                        var hipotenusa = Math.sqrt(ancho ** 2 + alto ** 2);
                        var angle = rad_to_degrees(Math.atan2(alto, ancho));
                        //   console.log('AAAAAAAAANGULO ', angle)
                        if (angle < 0) {
                            angle += 360; // Convert negative angles to positive
                        }

                        var lastClickedX =
                            clickedCoordinates[clickedCoordinates.length - 1].x;
                        var lastClickedY =
                            clickedCoordinates[clickedCoordinates.length - 1].y;

                        /*
                        angulo_currentDiv.innerHTML =
                            "<div>" + angle + "</div>";
                            */
                        ctx.strokeStyle = "blue";
                        ctx.lineWidth = 2;
                        ctx.beginPath();
                        ctx.moveTo(
                            lastClickedX / scaleX,
                            lastClickedY / scaleY,
                        );
                        ctx.lineTo(
                            currentMousePosition.x / scaleX,
                            currentMousePosition.y / scaleY,
                        );
                        ctx.stroke();
                        ctx.font = "12px Arial";
                        ctx.fillStyle = "darkred"; // Set the text color to red

                        if (debug_) {
                            ctx.fillText(
                                "(" +
                                    currentMousePosition.x +
                                    ", " +
                                    currentMousePosition.y +
                                    ") Angle: " +
                                    angle.toFixed(2) +
                                    "°",
                                currentMousePosition.x / scaleX + 10,
                                currentMousePosition.y / scaleY,
                            );
                        }
                    }

                    if (clickedCoordinates.length == 1 && is_mobile) {
                        // pintar una cruz, para el movil al menos

                        const radius = 10; // Radius of the circle
                        const fillColor = "red"; // Fill color of the circle

                        // Draw the circle
                        ctx.beginPath();
                        ctx.arc(x, y, radius, 0, 2 * Math.PI); // Draws a full circle
                        ctx.fillStyle = fillColor;
                        ctx.fill();
                        ctx.closePath();
                    }
                }),
            );
        };

        /*
        function get_image_index(image_name) {
            for (var i in window.images_loaded) {
                if (window.images_loaded[i].filename == image_name) {
                    return i;
                }
            }
        }
        */
    });

    function image_container_init() {
        if (!is_mobile) {
            var tooltips = document.querySelectorAll(
                '[data-bs-toggle="tooltip"]',
            );
            for (var t of tooltips) {
                new bootstrap.Tooltip(t, {});
            }
        }
        gallery_hand_selection_init();
    }

    function canvas_init(el) {
        canvas = document.getElementById("myCanvas");
        ctx = canvas.getContext("2d");
        window.canvas = canvas;
    }

    function gallery_hand_selection_init(event) {
        let gallery_2 = document.getElementById("gallery_2");
        let gallery_2_selection = gallery_2.querySelectorAll(".selection")[0];
        let startX, startY;

        gallery_2.style.backgroundColor = "";

        let isMouseDown = false;

        gallery_2.addEventListener("mousedown", (event) => {
            isMouseDown = true;

            startX = event.clientX - gallery_2.getBoundingClientRect().left;
            startY = event.clientY - gallery_2.getBoundingClientRect().top;
            gallery_2_selection.style.top = startY + "px";
            gallery_2_selection.style.left = startX + "px";

            console.log("Mouse Down at ", startX, ",", startY);
        });

        gallery_2.addEventListener("mousemove", (event) => {
            if (isMouseDown) {
                const currentX =
                    event.clientX - gallery_2.getBoundingClientRect().left;
                const currentY =
                    event.clientY - gallery_2.getBoundingClientRect().top;

                //const width = Math.abs(currentX - startX)
                //const height = Math.abs(currentY - startY)

                let width = currentX - startX;
                let height = currentY - startY;

                if (width < 0) {
                    width = -width;
                    gallery_2_selection.style.left = startX - width + "px";
                }
                if (height < 0) {
                    height = -height;
                    gallery_2_selection.style.top = startY - height + "px";
                }
                console.log(
                    "Mouse Moved to",
                    event.clientX,
                    event.clientY,
                    "....... width: ",
                    width,
                    " - height:",
                    height,
                );

                gallery_2_selection.style.width = width + "px";
                gallery_2_selection.style.height = height + "px";
                gallery_2_selection.style.border = "2px solid blue";
            }
        });

        gallery_2.addEventListener("click", (event) => {
            gallery_2_selection.style.width = 0;
            gallery_2_selection.style.height = 0;
            gallery_2_selection.style.border = "none";
        });
        gallery_2.addEventListener("mouseup", (event) => {
            if (isMouseDown) {
                isMouseDown = false;
                console.log("Mouse Up");

                const currentX =
                    event.clientX - gallery_2.getBoundingClientRect().left;
                const currentY =
                    event.clientY - gallery_2.getBoundingClientRect().top;

                let width = currentX - startX;
                let height = currentY - startY;

                console.log("width ", width);
                console.log("height ", height);
                if (width < 10 && height < 10) {
                    console.log("Not dragging (yet)");
                    return;
                }
                if (width < 0) {
                    width = -width;
                    gallery_2_selection.style.left = startX - width + "px";
                }
                if (height < 0) {
                    height = -height;
                    gallery_2_selection.style.top = startY - height + "px";
                }

                console.log("MOUSE UP WITH COORDIANTES X start =", startX);
                console.log("MOUSE UP WITH COORDIANTES Y start =", startY);
                console.log("MOUSE UP WITH COORDIANTES width =", width);
                console.log("MOUSE UP WITH COORDIANTES height =", height);

                console.log("STARTX = ", startX);
                console.log("STARTY = ", startY);
                console.log("currentX = ", currentX);
                console.log("currentY = ", currentY);

                var cornerTopLeft = {
                    x: startX < currentX ? startX : currentX,
                    y: startX < currentX ? startY : currentY,
                };
                var cornerBottomRight = {
                    x: startX > currentX ? startX : currentX,
                    y: startX > currentX ? startY : currentY,
                };
                // hay que sumar el desplazamiento del div donde estan
                cornerTopLeft.x += document
                    .getElementById("gallery_2")
                    .getBoundingClientRect().left;
                cornerBottomRight.x += document
                    .getElementById("gallery_2")
                    .getBoundingClientRect().left;

                cornerTopLeft.y += document
                    .getElementById("gallery_2")
                    .getBoundingClientRect().top;
                cornerBottomRight.y += document
                    .getElementById("gallery_2")
                    .getBoundingClientRect().top;

                console.log("cornerTopLeft");
                console.log(cornerTopLeft);
                console.log("cornerBottomRight");
                console.log(cornerBottomRight);
                // MAS FACIL
                gallery_2_selection.getBoundingClientRect();
                console.log("gallery_2_selection.getBoundingClientRect()");
                console.log(gallery_2_selection.getBoundingClientRect());

                // what is selected ??
                var images_gallery = document.querySelectorAll(
                    ".image-container-wrapper",
                );

                console.log(
                    "----------------------------- ESTA BE FORMULA SI Y GROWS CAP A BAIX=========?",
                );
                for (var im of images_gallery) {
                    var is_inside = false;
                    var coord = im.getBoundingClientRect();

                    console.log("coord");
                    console.log(coord);
                    if (
                        cornerTopLeft.x < coord.right &&
                        cornerBottomRight.x > coord.left &&
                        cornerTopLeft.y < coord.bottom &&
                        cornerBottomRight.y > coord.top
                    ) {
                        is_inside = true;
                    }

                    var i = parseInt(im.getAttribute("data-image-i"));
                    console.log("Image " + i + " --- is_inside: " + is_inside);
                    if (is_inside) {
                        myGallery.images[i].checked = true;
                    } else {
                        myGallery.images[i].checked = false;
                    }
                }

                gallery_2_selection.style.width = 0;
                gallery_2_selection.style.height = 0;
                gallery_2_selection.style.border = "none";

                event.stopPropagation();
            }
        });
    }

    window.debug_svelte = function () {
        debugger;
    };

    function display_origin(ctx, label) {
        if (!debug_) return false;

        if (!label) label = "";
        if (!window.display_origin_counter) window.display_origin_counter = 0;
        window.display_origin_counter++;

        ctx.strokeStyle = "blue";
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(0, 20);
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(20, 0);
        ctx.stroke();

        ctx.font = "12px Arial";
        ctx.fillStyle = "darkred"; // Set the text color to red
        ctx.fillText("N " + window.display_origin_counter + label, 15, 15);
    }

    /**
     * 
     * 
*
*
    * 
     * 
*
*
    * 
     * 
*
*
    * 
     * 
*
*

    */
    function worker_install() {
        console.log("worker_install");
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker
                .register("sw.js")
                .then((registration) => {
                    console.log("Service worker registered:", registration);

                    window.reg = registration;
                    console.log("Service worker registered:", registration);

                    function listenForWaitingServiceWorker(reg, callback) {
                        function awaitStateChange() {
                            reg.installing.addEventListener(
                                "statechange",
                                function () {
                                    // if (this.state === 'installed') callback(reg);
                                },
                            );
                        }
                        if (!reg) return;
                        if (reg.waiting) return callback(reg);
                        if (reg.installing) awaitStateChange();
                        reg.addEventListener("updatefound", awaitStateChange);
                    }

                    // reload once when the new Service Worker starts activating
                    var refreshing;
                    navigator.serviceWorker.addEventListener(
                        "controllerchange",
                        function () {
                            if (refreshing) return;
                            refreshing = true;
                            window.location.reload();
                        },
                    );
                    function promptUserToRefresh(reg) {
                        // this is just an example
                        // don't use window.confirm in real life; it's terrible
                        if (
                            window.confirm(
                                "New version available! OK to refresh?",
                            )
                        ) {
                            reg.waiting.postMessage("skipWaiting");
                        }
                    }
                    listenForWaitingServiceWorker(reg, promptUserToRefresh);
                })
                .catch((error) => {
                    console.log("Service worker registration failed:", error);
                });
        }
    }

    let deferredPrompt;
    let deferredPrompt_listener_installed = false;

    window.addEventListener("beforeinstallprompt", (event) => {
        console.log("beforeinstallprompt");
        // Prevent the default prompt
        event.preventDefault();
        // Display your custom prompt UI
        // Store the event for later use when the user interacts with your UI
        // You can then call `event.prompt()` to show the native prompt
        deferredPrompt = event;

        var pwa_install_btn = document.querySelectorAll(".pwa_install")[0];

        if (deferredPrompt) {
            pwa_install_btn.style.display = "block";

            if (deferredPrompt_listener_installed) return;

            pwa_install_btn.addEventListener("click", () => {
                console.log("user clicked to install");
                // Show the native installation prompt
                deferredPrompt.prompt();
                // Wait for the user's choice
                deferredPrompt.userChoice.then((choiceResult) => {
                    if (choiceResult.outcome === "accepted") {
                        console.log("User accepted the installation prompt");
                    } else {
                        console.log("User dismissed the installation prompt");
                    }
                    // Clear the deferred prompt variable
                    deferredPrompt = null;
                });
            });
            deferredPrompt_listener_installed = true;
        }
    });

    window.addEventListener("appinstalled", (event) => {
        // App installation completed
        // Perform any necessary actions
        var pwa_install_btn = document.querySelectorAll(".pwa_install")[0];
        pwa_install_btn.remove();
        console.log("App INSTALLED");
    });

    if (navigator.getInstalledRelatedApps) {
        navigator.getInstalledRelatedApps().then((apps) => {
            apps.forEach((app) => {
                console.log("APP: " + app);
                if (
                    app.platform === "android" &&
                    app.url === window.location.origin
                ) {
                    // App is already installed, hide the install prompt
                    event.preventDefault();
                    return false;
                }
            });
        });
    }

    function getPWADisplayMode() {
        const isStandalone = window.matchMedia(
            "(display-mode: standalone)",
        ).matches;
        if (document.referrer.startsWith("android-app://")) {
            // Trusted Web Activity

            return "twa";
        } else if (navigator.standalone || isStandalone) {
            return "standalone";
        }
        return "browser";
    }

    window
        .matchMedia("(display-mode: standalone)")
        .addEventListener("change", (evt) => {
            let displayMode = "browser";
            if (evt.matches) {
                displayMode = "standalone";
            }
            // Log display mode change to analytics
            console.log("DISPLAY_MODE_CHANGED", displayMode);
        });

    let displayMode = getPWADisplayMode();
    console.log("displayMode 0000000000000 ", displayMode);
    /* 
if (
        displayMode  == "standalone" &&
        navigator.userAgent.toLowerCase().indexOf("android") > -1
    ) {
        
        document.querySelectorAll('.installed_hide').forEach((el)=>{
            el.style.display = 'none'
            })
    } else if (displayMode == "browser") {
        //jQuery('.install_suggest').show();
    } else if (displayMode != "browser") {
        //jQuery('.install_suggest').remove();
        document.querySelectorAll('.installed_hide').forEach((el)=>{
            el.style.display = 'none'
        })
    }
*/
</script>

<main>
    <div id="app">
        <div id="loading_backdrop" style="display:none">Loading ...</div>
        {#if debug_}
            <ul
                onClick="this.remove();"
                id="tasks"
                style="background:rgb(255 243 194);position:fixed;bottom:0;left:0;padding:15px;    margin: 0;;font-size:10px;"
            >
                <li class="completed">
                    4. UPLOAD DOMAIN: qualyaapps -> test movil
                </li>
                <li>
                    5. android app packaging TWA? permisos llegir/escriure
                    fotos?
                </li>
                <li>6. NEXT: Autorotate (VISION/DL/ML) + options</li>
            </ul>
        {/if}
        <div class="header installed_hide">
            <div class="container">
                <div class="row">
                    <div class="col-8">
                        <h1>Qualya Image Rotator</h1>
                        <h2>
                            The easiest way to adjust the rotation of your
                            pictures
                        </h2>
                    </div>
                    <div class="col-4">
                        <div style="text-align:right;">
                            <p>
                                <a
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal_faq"
                                    href="/ ">How It works</a
                                >
                            </p>
                            <p>
                                <a
                                    class="pwa_install"
                                    style="display:none"
                                    href="#a"
                                    onClick="return false;">Install</a
                                >
                            </p>
                        </div>
                    </div>
                </div>

                {#if tutorial}
                    <div class="row">
                        <div class="col-12 center">
                            <h4 style="text-align:center">
                                <a
                                    href="#a"
                                    onClick="return false;"
                                    on:click={() => {
                                        load_demo_tutorial();
                                        return false;
                                    }}>Try the demo</a
                                >
                            </h4>
                        </div>
                    </div>
                {/if}

                <div style="clear:both" />
            </div>
            <!-- 
            {@debug name}
            -->

            <hr />
        </div>
        <!--
        <div class="container">
            <div class="tutorial alert alert-primary">
                <div style="text-align:right">
                    <a
                        href="#a"
                        onClick="document.querySelectorAll('.tutorial')[0].remove();return false;"
                        >[X]</a
                    >
                </div>
                <h3>Tutorial</h3>
                <p>To correct a rotation easily:</p>
                <p>
                    1) Load images. 2) Click on any. 3) <a href="#a"
                        >Draw a line of what should be the vertical or
                        horizontal axis of fhe picture</a
                    >
                </p>

                <br />
            </div>
        </div>
        <br />
        -->
        <div class="container">
            <div class="row">
                <!--
                {#if myGallery.images.length}
                    <div class="col-12 col-sm-12" use:canvas_init>
                        <div class="center">
                            <canvas id="myCanvas">Load images</canvas>
                        </div>
                        <br />
                        {#if myGallery.getSelectedImage() && myGallery.getSelectedImage().rotation != 0}
                            <div class="center">
                                <button
                                    id="rotation_reset"
                                    on:click={reset_current_rotation}
                                    >Reset</button
                                >
                            </div>
                        {/if}
                        <br />
                        <br />
                        <br />
                        <br />
                    </div>
                {/if}
                -->
                <div class="col-12 col-sm-12" style="position:relative">
                    <br />
                    <!--<h4>
                        {#if !myGallery.images.length}
                            Load Images
                        {:else}
                            Gallery
                        {/if}
                    </h4>-->
                    {#if myGallery.images.length && !myGallery.getSelectedImage()}
                        <div class="menu_all" style="">
                            <a
                                href="#a"
                                on:click={() => {
                                    document
                                        .getElementById("files_picker")
                                        .click();
                                    return false;
                                }}
                                onClick="return false"
                            >
                                <img
                                    alt=""
                                    src="img/anyadir.png"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    title="Load more images"
                                />
                            </a>

                            <br />
                            <br />

                            <a
                                href="#a"
                                on:click={() => {
                                    var loading_rotation = true;
                                    var backdrop =
                                        document.getElementById(
                                            "loading_backdrop",
                                        );
                                    backdrop.style.display = "block";

                                    setTimeout(() => {
                                        rotate_all_canvas("right");
                                        var backdrop =
                                            document.getElementById(
                                                "loading_backdrop",
                                            );
                                        backdrop.style.display = "none";
                                        loading_rotation = false;
                                    }, 100);
                                }}
                                onClick="return false"
                            >
                                <img
                                    alt="Rotate Right"
                                    src="img/rotate-right.png"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    title="Rotate all/selected images right"
                                />
                            </a>

                            <br />
                            <br />

                            <a
                                href="#a"
                                on:click={() => {
                                    var loading_rotation = true;
                                    var backdrop =
                                        document.getElementById(
                                            "loading_backdrop",
                                        );
                                    backdrop.style.display = "block";
                                    setTimeout(() => {
                                        rotate_all_canvas("left");
                                        var backdrop =
                                            document.getElementById(
                                                "loading_backdrop",
                                            );
                                        backdrop.style.display = "none";
                                        loading_rotation = false;
                                    }, 100);
                                }}
                                onClick="return false"
                            >
                                <img
                                    alt=""
                                    src="img/rotate-left.png"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    title="Rotate all/selected images left"
                                />
                            </a>

                            <br />
                            <br />

                            <a
                                href="#a"
                                on:click={() => delete_all()}
                                onClick="return false"
                                ><img
                                    alt=""
                                    src="img/delete.png"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    title="Delete all/selected images"
                                />
                            </a>

                            <br />
                            <br />

                            <a
                                href="#a"
                                on:click={() => {
                                    if (
                                        !myGallery.imagesIndexesWithPropertyTrue(
                                            "checked",
                                        ).length
                                    ) {
                                        //check la primera
                                        myGallery.images[0].checked = true;
                                    } else {
                                        //uncheck all
                                        myGallery.editAllImagesProperty(
                                            "checked",
                                            false,
                                        );
                                        myGallery = myGallery;
                                    }
                                }}
                                onClick="return false"
                            >
                                <img
                                    alt=""
                                    src="img/check-unchecked.png"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    title="Select/unselect all/selected images"
                                />
                            </a>

                            <br />
                            <br />

                            <a
                                href="#a"
                                on:click={async (e) => {
                                    if (window.gallery_images_downloading)
                                        return false;
                                    var _this = e.target.parentNode;
                                    var html = _this.innerHTML;
                                    console.log("ineer html");
                                    console.log(e);
                                    console.log(html);
                                    document.getElementById(
                                        "img_download_link",
                                    ).style.display = "none";
                                    document.getElementById(
                                        "img_download_wait",
                                    ).style.display = "";

                                    // _this.innerHTML =   '<img class="rotate_animation" alt="" src="img/download-wait.png" />';
                                    window.gallery_images_downloading = true;
                                    await download_rotated_images();
                                    //_this.innerHTML = html;
                                    window.gallery_images_downloading = false;

                                    document.getElementById(
                                        "img_download_link",
                                    ).style.display = "";
                                    document.getElementById(
                                        "img_download_wait",
                                    ).style.display = "none";
                                }}
                                onClick="return false"
                            >
                                <img
                                    id="img_download_link"
                                    alt=""
                                    src="img/download.png"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    title="Download all images"
                                />
                                <img
                                    id="img_download_wait"
                                    style="display:none"
                                    class="rotate_animation"
                                    alt=""
                                    src="img/download-wait.png"
                                />
                            </a>
                        </div>
                    {/if}
                    <input
                        style="display:none"
                        type="file"
                        id="files_picker"
                        accept="image/*"
                        multiple
                    />
                    <br />
                    <div class="gallery_2_wrapper">
                        <div id="gallery_2" class="row">
                            <div class="selection" />
                            {#each myGallery.images as im, i}
                                <div
                                    class="image-container col-12 col-sm-2"
                                    use:image_container_init
                                >
                                    <div
                                        class="image-container-wrapper"
                                        data-image-i={i}
                                        class:gallery-image-selected={im.checked}
                                        class:gallery-image-no-selected={myGallery.imagesIndexesWithPropertyTrue(
                                            "checked",
                                        ).length && !im.checked}
                                    >
                                        <div class="image-container-delete">
                                            <a
                                                href="#a"
                                                onClick="return false"
                                                on:click={() => {
                                                    galeria_imagen_borrar(i);
                                                    return false;
                                                }}
                                                ><img
                                                    alt=""
                                                    src="img/delete.png"
                                                /></a
                                            >
                                        </div>
                                        <div class="image-container-check">
                                            <input
                                                style="display:none"
                                                type="checkbox"
                                                bind:checked={im.checked}
                                            />
                                            <img
                                                alt=""
                                                on:keypress={() => true}
                                                on:click={() =>
                                                    (im.checked = !im.checked)}
                                                style="width:40px"
                                                src={im.checked
                                                    ? "img/check-checked.png"
                                                    : "img/check-unchecked.png"}
                                            />
                                        </div>

                                        <div
                                            class="image-container-open-image-tab"
                                            style="margin-top:80px"
                                        >
                                            <a
                                                href="#a"
                                                onClick="return false"
                                                on:click={async () => {
                                                    var img__ =
                                                        await img_full_of_rotated_image(
                                                            i,
                                                        );

                                                    if (im.image_rotated) {
                                                        console.log(
                                                            im.image_rotated
                                                                .src,
                                                        );
                                                        // window.open(im.image_rotated.src, "_blank")
                                                        const win =
                                                            window.open();
                                                        win.document.write(
                                                            //`<img src="${im.image_rotated.src}" style="max-width:100%;"/>`,
                                                            `<img src="${img__}" style="max-width:100%;"/>`,
                                                        );
                                                        win.document.close();
                                                    } else {
                                                        console.log(
                                                            im.image.src,
                                                        );
                                                        /*
                                                    window.open(
                                                        im.image.src,
                                                        "_blank",
                                                    );
                                                    */

                                                        const win =
                                                            window.open();
                                                        win.document.write(
                                                            //`<img src="${im.image.src}" style="max-width:100%;"/>`,
                                                            `<img src="${img__}" style="max-width:100%;"/>`,
                                                        );
                                                        win.document.close();
                                                    }

                                                    return false;
                                                }}
                                                ><img
                                                    alt=""
                                                    src="img/zoom.png"
                                                />
                                            </a>
                                        </div>

                                        <div
                                            class="image-container-copy-image"
                                            style="margin-top:80px"
                                        >
                                            <a
                                                href="#a"
                                                onClick="return false"
                                                on:click={async (e) => {
                                                    var img__ =
                                                        await img_full_of_rotated_image(
                                                            i,
                                                        );

                                                    var target =
                                                        e.currentTarget;

                                                    const style =
                                                        getComputedStyle(
                                                            target,
                                                        );
                                                    if (
                                                        style.position ===
                                                        "static"
                                                    ) {
                                                        target.style.position =
                                                            "relative";
                                                    }

                                                    const existing =
                                                        target.querySelector(
                                                            ".copy-badge",
                                                        );
                                                    if (existing)
                                                        existing.remove();

                                                    const badge =
                                                        document.createElement(
                                                            "span",
                                                        );
                                                    badge.className =
                                                        "copy-badge";
                                                    badge.textContent =
                                                        "Copied!";

                                                    target.appendChild(badge);

                                                    // Remove after animation completes
                                                    setTimeout(() => {
                                                        badge.remove();
                                                    },2500);

                                                    // aqui, img___ transformar a dataurl para copiar en el clipboard el full
                                                    const img_bigger =
                                                        new Image();

                                                    // Set the source to the Base64 string
                                                    img_bigger.src = img__;

                                                    if (im.image_rotated) {
                                                        await copyImageElementToClipboard(
                                                            //im.image_rotated, // tamaño thumbnail
                                                            img_bigger,
                                                        );
                                                    } else {
                                                        await copyImageElementToClipboard(
                                                            //im.image, // tamaño thumbnail
                                                            img_bigger,
                                                        );
                                                    }

                                                    return false;
                                                }}
                                                ><img
                                                    alt=""
                                                    src="img/copy.png"
                                                />
                                            </a>
                                        </div>

                                        <div class="image-container-download">
                                            <a
                                                href="#a"
                                                onClick="return false"
                                                on:click={() => {
                                                    galeria_imagen_download(i);
                                                    return false;
                                                }}
                                                ><img
                                                    alt=""
                                                    src="img/download.png"
                                                /></a
                                            >
                                        </div>

                                        <a
                                            href="#a"
                                            onClick="return false"
                                            on:click={(e) => {
                                                // select
                                                if (
                                                    myGallery.imagesIndexesWithPropertyTrue(
                                                        "checked",
                                                    ).length
                                                ) {
                                                    im.checked = !im.checked;
                                                } else {
                                                    galeria_imagen_click(i);
                                                }

                                                return;
                                                im.checked = !im.checked;
                                                if (e.detail === 1) {
                                                    // do something if the element was clicked once.
                                                    console.log(
                                                        "DETAIL LICK 1",
                                                    );
                                                } else if (e.detail === 2) {
                                                    // do something else if the element was clicked twice
                                                    console.log(
                                                        "DETAIL LICK 2",
                                                    );
                                                }
                                            }}
                                            on:dblclick={() => {
                                                if (
                                                    myGallery.imagesIndexesWithPropertyTrue(
                                                        "checked",
                                                    ).length
                                                ) {
                                                    //im.checked = !im.checked;
                                                    //galeria_imagen_click(i);
                                                } else {
                                                    //galeria_imagen_click(i);
                                                }
                                            }}
                                        >
                                            {#if im.image_rotated}
                                                <img
                                                    src={im.image_rotated.src}
                                                    alt=""
                                                />
                                            {:else}
                                                <img
                                                    src={im.image.src}
                                                    alt=""
                                                />
                                            {/if}
                                        </a>
                                        <!-- {im.filename}-->
                                    </div>
                                </div>
                            {/each}
                        </div>
                    </div>
                    {#if myGallery.images.length}
                        <!--<div class="center">
                            <button
                                id="download_images"
                                on:click={async (e) => {
                                    var html = e.target.innerHTML;
                                    console.log(e);
                                    e.target.innerHTML = "Downloading...";
                                    await download_rotated_images();
                                    e.target.innerHTML = html;
                                }}>Download images</button
                            >
                            <br />
                            <br />
                        </div>-->
                    {/if}
                    <div
                        id="drop_area"
                        on:dragenter={(ev) => {
                            ev.preventDefault();
                            ev.target.classList.add("files_over");
                            return false;
                        }}
                        on:dragleave={(ev) => {
                            ev.preventDefault();
                            ev.target.classList.remove("files_over");
                            return false;
                        }}
                        on:drop={(ev) => {
                            ev.preventDefault();
                            ev.target.classList.remove("files_over");
                            //dropped_files(ev);
                            console.log(ev);
                            let files = ev.dataTransfer.files;
                            files = Array.from(files).filter((file) =>
                                file.type.startsWith("image/"),
                            );
                            console.log(files);
                            if (tutorial) {
                                // borrar imagenes tutorial si las hay
                                if (myGallery.images.length == 1)
                                    myGallery.removeImage(0);
                            }
                            tutorial = false;
                            gallery_add_files(files);
                            return false;
                        }}
                        on:ondragover={(ev) => {
                            ev.preventDefault();
                            return false;
                        }}
                        on:click={(ev) => {
                            document.getElementById("files_picker").click();
                            return false;
                        }}
                        on:keydown={(ev) => false}
                        on:keyup={(ev) => false}
                        on:keypress={(ev) => false}
                        ondragover="return false"
                        style="width:100%;height:100px;text-align:center;border:dashed 2px black;    display: flex;
                    flex-direction: column;
                    justify-content: space-around;"
                    >
                        Drop files here OR click to select them
                        <br />
                        <br />
                        You can also press Ctrl+v to get from clipboard
                    </div>
                    <br />
                    <div id="gallery" class="row">&nbsp;</div>

                    <br />
                    {#if myGallery.images.length}
                        <div>
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div>
                                        <!--
                                        <h4>Options (REPLEGABLE)</h4>
                                        <div>
                                            <label
                                                ><input
                                                    id="option_hide_white"
                                                    class="option_hide_white"
                                                    type="checkbox"
                                                    checked
                                                /> Fill all image after rotation
                                                (to prevent blank corners)</label
                                            >
                                        </div>
                                    -->
                                    </div>
                                    <div>
                                        <!--
                                        <br />
                                        <h4>Finish</h4>
                                        <button
                                            id="download_images"
                                            on:click={async (e) => {
                                                var html = e.target.innerHTML;
                                                console.log(e);
                                                e.target.innerHTML = "Downloading...";
                                                await download_rotated_images();
                                                e.target.innerHTML = html;
                                            }}>Download corrected images</button
                                        >
                                        -->
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <!-- <h4>Actions for this picture</h4>-->
                                    <div>
                                        <!--
                                        {#if myGallery.getSelectedImage() && myGallery.getSelectedImage().rotation != 0}
                                            <div>
                                                <a
                                                    href="#a"
                                                    on:click={reset_current_rotation}
                                                    onClick="return false"
                                                    >Reset rotation</a
                                                >
                                            </div>
                                        {/if}
                                        -->

                                        <!-- 
                                        <div>
                                            <a
                                                href="#a"
                                                on:click={() =>
                                                    rotate_current_canvas(
                                                        "right"
                                                    )}
                                                onClick="return false"
                                                >ROTATE CANVAS 90</a
                                            >
                                        </div>
                                        <div>
                                            <a
                                                href="#a"
                                                on:click={() =>
                                                    rotate_current_canvas(
                                                        "left"
                                                    )}
                                                onClick="return false"
                                                >ROTATE CANVAS -90</a
                                            >
                                        </div>
                                        -->
                                    </div>

                                    <!--
                                    <h4>
                                        {#if !myGallery.imagesIndexesWithPropertyTrue("checked").length}
                                            All pictures
                                        {:else}
                                            Selected pictures
                                        {/if}
                                    </h4>

                                    <div>
                                        <div>
                                            <a
                                                href="#a"
                                                on:click={() =>
                                                    rotate_all_canvas("right")}
                                                onClick="return false"
                                                >ROTATE
                                                {#if !myGallery.imagesIndexesWithPropertyTrue("checked").length}all{:else}selected{/if}
                                                CANVAS 90</a
                                            >
                                        </div>
                                        <div>
                                            <a
                                                href="#a"
                                                on:click={() =>
                                                    rotate_all_canvas("left")}
                                                onClick="return false"
                                                >ROTATE
                                                {#if !myGallery.imagesIndexesWithPropertyTrue("checked").length}all{:else}selected{/if}
                                                CANVAS -90</a
                                            >
                                        </div>
                                        {#if myGallery.imagesIndexesWithPropertyTrue("checked").length}
                                            <a
                                                href="#a"
                                                on:click={() => {
                                                    myGallery.editAllImagesProperty(
                                                        "checked",
                                                        false
                                                    );
                                                    myGallery = myGallery;
                                                }}
                                                onClick="return false"
                                                >Uncheck all</a
                                            >
                                        {/if}

                                        <div>
                                            <a
                                                href="#a"
                                                on:click={() => delete_all()}
                                                onClick="return false"
                                                >DELETE
                                                {#if !myGallery.imagesIndexesWithPropertyTrue("checked").length}all{:else}selected{/if}
                                            </a>
                                        </div>
                                    </div>
                                    -->
                                </div>
                            </div>
                        </div>
                    {/if}
                </div>
            </div>
            <div id="test" />
        </div>
    </div>
    <!---<img id="myImage" alt="Canvas Image" />-->

    <div
        class="modal fade"
        id="modal_canvas"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content">
                <!--<div class="modal-header">
                    <h5 class="modal-title">Modal title</h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    />
                </div> -->
                <div
                    class="modal-body"
                    onClick="window.modal.hide();console.log('modalbody clicked');"
                >
                    <a href="#a" data-bs-dismiss="modal" onClick="return false;"
                        ><img
                            class="backdrop_button"
                            alt=""
                            src="img/back.png"
                        /></a
                    >

                    <div style="float:right">
                        <a
                            href="#a"
                            onClick="return false"
                            data-bs-dismiss="modal"
                            on:click={() => {
                                var i_ = myGallery.getSelectedImageIndex();

                                galeria_imagen_borrar(i_);
                                setTimeout(function () {
                                    if (myGallery.images.length) {
                                        galeria_imagen_click(i_);
                                    }
                                }, 500);

                                return false;
                            }}
                            ><img
                                class="backdrop_button"
                                alt=""
                                src="img/delete.png"
                            />
                        </a>
                    </div>
                    <!--<button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal">Close</button
                    >-->

                    {#if myGallery.images.length}
                        <div class="col-12 col-sm-12" use:canvas_init>
                            <div class="center">
                                {#if tutorial}
                                    <div
                                        class="badge text-bg-light tutorial_tag"
                                    >
                                        To adjust rotation draw a line
                                        indicating what should be the vertical
                                        or horizontal axis.
                                        <br />

                                        Like the arrows shown
                                    </div>
                                {/if}
                                <br />
                                <canvas
                                    id="myCanvas"
                                    onClick="event.stopPropagation();console.log('canvas click');"
                                    >Load images</canvas
                                >
                                <br />
                            </div>
                            <br />

                            <div class="center">
                                <a
                                    href="#a"
                                    on:click={() => {
                                        console.log("rotate left svelte click");
                                        var loading_rotation = true;
                                        var backdrop =
                                            document.getElementById(
                                                "loading_backdrop",
                                            );
                                        backdrop.style.display = "block";
                                        setTimeout(() => {
                                            rotate_current_canvas("left");
                                            var backdrop =
                                                document.getElementById(
                                                    "loading_backdrop",
                                                );
                                            backdrop.style.display = "none";
                                            loading_rotation = false;
                                        }, 100);
                                    }}
                                    onClick="console.log('rotate left DOM click');event.stopPropagation();return false;"
                                >
                                    <!-- ROTATE 90-->
                                    <img
                                        class="backdrop_button"
                                        alt=""
                                        src="img/rotate-left.png"
                                    />
                                </a>
                                &nbsp;

                                {#if myGallery.getSelectedImage() && myGallery.getSelectedImage().rotation != 0}
                                    <a
                                        href="#a"
                                        on:click={reset_current_rotation}
                                        onClick="event.stopPropagation();return false;"
                                    >
                                        <!-- ROTATE 90-->
                                        <img
                                            class="backdrop_button"
                                            alt=""
                                            src="img/reset.png"
                                        />
                                    </a>
                                    &nbsp;
                                    <a
                                        href="#a"
                                        on:click={async (e) => {
                                            if (
                                                window.gallery_images_downloading
                                            )
                                                return false;
                                            var _this = e.target.parentNode;
                                            var html = _this.innerHTML;
                                            document.getElementById(
                                                "img_download_link_on_canvas",
                                            ).style.display = "none";
                                            document.getElementById(
                                                "img_download_link_on_canvas_wait",
                                            ).style.display = "";
                                            window.gallery_images_downloading = true;
                                            await download_current_rotated_image();
                                            window.gallery_images_downloading = false;
                                            document.getElementById(
                                                "img_download_link_on_canvas",
                                            ).style.display = "";
                                            document.getElementById(
                                                "img_download_link_on_canvas_wait",
                                            ).style.display = "none";
                                        }}
                                        onClick="event.stopPropagation();return false;"
                                    >
                                        <img
                                            id="img_download_link_on_canvas"
                                            class="backdrop_button"
                                            alt=""
                                            src="img/download.png"
                                            title="Download all images"
                                        />
                                        <img
                                            id="img_download_link_on_canvas_wait"
                                            class="backdrop_button rotate_animation"
                                            style="display:none"
                                            alt=""
                                            src="img/download-wait.png"
                                        />
                                    </a>

                                    &nbsp;
                                {/if}

                                <a
                                    href="#a"
                                    on:click={() => {
                                        console.log(
                                            "rotate right svelte click",
                                        );
                                        var loading_rotation = true;
                                        var backdrop =
                                            document.getElementById(
                                                "loading_backdrop",
                                            );
                                        backdrop.style.display = "block";
                                        setTimeout(() => {
                                            rotate_current_canvas("right");
                                            var backdrop =
                                                document.getElementById(
                                                    "loading_backdrop",
                                                );
                                            backdrop.style.display = "none";
                                            loading_rotation = false;
                                        }, 100);
                                    }}
                                    onClick="event.stopPropagation();return false;"
                                >
                                    <!-- ROTATE -90-->
                                    <img
                                        class="backdrop_button"
                                        alt=""
                                        src="img/rotate-right.png"
                                    />
                                </a>
                            </div>
                        </div>
                    {/if}
                </div>
                <!--  <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal">Close</button
                    >
                    <button type="button" class="btn btn-primary"
                        >Save changes</button
                    >
                </div>
-->
            </div>
        </div>
    </div>

    <!-- Modal -->
    <div
        class="modal fade"
        id="modal_faq"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">FAQ</h1>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    />
                </div>
                <div class="modal-body">
                    <ul>
                        <li>
                            <h3>What is Qualya Image rotator?</h3>
                            <div>
                                <p>
                                    This is a web software utility to rotate
                                    your images.
                                </p>
                                <p>
                                    You can rotate them both individually or in
                                    bulk. Individual rotation let's you
                                    fine-adjust the rotation of he image
                                </p>
                                <p>
                                    To do a fine rotation draw a line in the
                                    image indicating what should be the
                                    horizontal or vertical axis
                                </p>
                            </div>
                            <br />
                        </li>
                        <li>
                            <h3>How fine rotation works</h3>
                            <ol>
                                <li>Load images</li>
                                <li>Click on any</li>
                                <li>
                                    Draw a line of what should be the vertical
                                    or horizontal axis of fhe picture
                                </li>
                                <li>
                                    Once images are corrected, just download
                                    them
                                </li>
                            </ol>
                            <br />
                            <p style="text-align:center">
                                <a
                                    href="#a"
                                    style="font-weight:800;font-style:italic;    text-decoration: none;"
                                    data-bs-dismiss="modal"
                                    onClick="return false;"
                                    on:click={() => {
                                        load_demo_tutorial();
                                        return false;
                                    }}>Load a demo image to check it</a
                                >
                            </p>
                            <br />
                        </li>
                        <li>
                            <h3>Installation</h3>
                            <p>
                                This application is a progressive web app. It
                                means you can install it in your computer for
                                acces without the browser.
                            </p>
                            <p class="installed_hide">
                                To do that <a
                                    href="#a"
                                    onClick="(document.querySelectorAll('.pwa_install')[0]).click();return false;"
                                    >click here</a
                                >.
                            </p>
                            <br />
                        </li>
                        <li>
                            <h3>About privacy / security</h3>

                            <p>
                                This web app is "local". It means that once the
                                page is loaded or is installed, it does not need
                                internet anymore
                            </p>
                            <p>
                                The images you load here never leave the
                                website.
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal">Close</button
                    >
                </div>
            </div>
        </div>
    </div>

    <!-- Modal -->
    <div
        class="modal fade"
        id="modal_contact"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">
                        Contact
                    </h1>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    />
                </div>
                <div class="modal-body">
                    You can contact us through
                    <br />
                    <a href="mailto:qualyapps@gmail.com">qualyapps@gmail.com</a>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal">Close</button
                    >
                </div>
            </div>
        </div>
    </div>

    <!-- Modal -->
    <div
        class="modal fade"
        id="modal_terms"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">
                        Terms & conditions
                    </h1>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    />
                </div>
                <div class="modal-body">
                    <div>
                        <ul>
                            <li>
                                By downloading, installing, or using this
                                software, you agree these terms and conditions.
                                If you do not agree with any part of these
                                terms, you may not use the app.
                            </li>
                            <li>
                                This software is of free usage and can be used
                                by anyone.
                            </li>
                            <li>
                                This software is provided on an "as is" basis.
                                The developer makes no warranties, expressed or
                                implied, and hereby disclaims and negates all
                                other warranties, including without limitation,
                                implied warranties or conditions of
                                merchantability, fitness for a particular
                                purpose, or non-infringement of intellectual
                                property or other violation of rights.
                            </li>
                            <li>
                                In no event shall the developer or its suppliers
                                be liable for any damages (including, without
                                limitation, damages for loss of data or profit,
                                or due to business interruption) arising out of
                                the use or inability to use this software, even
                                if the developer or a an authorized
                                representative has been notified orally or in
                                writing of the possibility of such damage.
                            </li>
                            <li>
                                This software makes no use of personal data -
                                excluding the content of the pictures. In any
                                case all data remains in your computer and no
                                data is transfered to any external server. All
                                data is treated locally
                            </li>
                            <li>
                                This software is treated as beta software in
                                evolution due to its web nature. The developer
                                reserves the right to modify or replace these
                                terms at any time. It is your responsibility to
                                review these terms periodically for changes.
                                Your continued use of this software following
                                the posting of any changes constitutes
                                acceptance of those changes.
                            </li>
                            <li>
                                You can contact the developer through the
                                contact section
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal">Close</button
                    >
                </div>
            </div>
        </div>
    </div>
</main>
<footer>
    <div class="container">
        <hr />

        <br />
        <br />
        <div class="row">
            <div class="col-6">
                <a data-bs-toggle="modal" data-bs-target="#modal_faq" href="/ "
                    >FAQ</a
                >
                &nbsp; &nbsp;
                <a data-bs-toggle="modal" data-bs-target="#modal_terms" href="/"
                    >Condition terms & Privacy</a
                >
                &nbsp; &nbsp;
                <a
                    data-bs-toggle="modal"
                    data-bs-target="#modal_contact"
                    href="/">Contact</a
                > &nbsp; &nbsp;
            </div>
            <div class="col-6" style="text-align:right">
                2023 - <a href="https://qualyaapps.com/" target="_BLANK"
                    >Qualya Apps</a
                >
            </div>
        </div>
    </div>
</footer>

<style>
    * {
        user-select: none;
    }
    :global(#gallery_2) {
        position: relative;
    }

    :global(.gallery_2_wrapper) {
        margin-right: 50px;
    }

    :global(#gallery_2 .selection) {
        position: absolute;
        border: 2px solid blue;
        border: none;
        width: 0;
        height: 0;
        top: 0;
        left: 0;
        z-index: 99999999;
    }

    :global(#gallery img),
    :global(#gallery_2 img) {
        max-width: 100px;
        max-width: 100%;
    }
    :global(.rotate_animation) {
        animation: rotate 5s linear infinite;
        transform-origin: center center;
    }

    :global(.modal-backdrop) {
        --bs-backdrop-opacity: 0.8;
        opacity: 0.8 !important;
    }

    @keyframes rotate {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }

    :global(img.backdrop_button) {
        background: white;
        padding: 5px;
        border-radius: 10px;
    }

    #modal_canvas .modal-content {
        background: none;

        border: none;
    }

    #loading_backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding-top: 200px;
        text-align: center;
        font-size: 35px;
        background: rgba(0, 0, 0, 0.5);
        color: #eee;
        z-index: 999999;
    }

    .modal {
    }

    .container {
        background: #fff;
        border-radius: 4px;
        padding: 0px;
        box-shadow: 0px 5px 10px #ccc;

        background: none;
        box-shadow: none;
    }

    #myCanvas {
        /*border: 1px solid #ccc;*/
        /*min-height: 200px;*/
    }

    .center {
        text-align: center;
    }

    #tasks .completed {
        text-decoration: line-through;
        color: green;
    }

    main {
        padding: 0em;
        /* max-width: 240px;*/
        margin: 0 auto;
    }

    #tasks {
        text-align: left;
    }
    @media (min-width: 640px) {
        main {
            max-width: none;
        }
    }

    :global(#drop_area.files_over) {
        background: yellow;
    }

    .tutorial_tag {
        position: relative;
        top: 60px;
    }

    .image-container {
        margin-bottom: 20px;
    }

    .gallery-image-selected {
        border: 3px solid red;
    }

    .gallery-image-no-selected {
        opacity: 0.4;
    }
    .image-container-wrapper {
        padding: 0px;
        background: #333;
        background: rgba(0, 0, 0, 0.1);
        height: 100%;

        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
    }

    .image-container-delete {
        position: absolute;
        top: 5px;
        right: 5px;
    }
    .image-container-copy-image img,
    .image-container-open-image-tab img,
    .image-container-check img,
    .image-container-download img,
    .image-container-delete img {
        max-width: 30px !important;
    }

    .image-container-copy-image {
        right: 75px;
        position: absolute;
        bottom: 5px;
    }
    .image-container-open-image-tab {
        position: absolute;
        bottom: 5px;
        right: 40px;
    }
    .image-container-check {
        position: absolute;
        top: 5px;
        left: 5px;
    }
    .image-container-download {
        position: absolute;
        bottom: 5px;
        right: 5px;
    }

    .menu_all {
        position: fixed;
        z-index: 99999;
        right: 5px;
    }

    .menu_all img {
        width: 50px;
    }

    h1 {
        color: #ff3e00;
        text-transform: uppercase;
        font-size: 1.5em;
        font-weight: 100;
    }
    h2 {
        font-size: 18px;
        font-weight: 200;
    }

    :global(.copy-badge) {
        position: absolute;
        top: 100%; /* just below the element */
        left: 50%;
        transform: translateX(-50%);
        margin-top: 6px;

        background: #333;
        color: #fff;
        font-size: 12px;
        padding: 4px 8px;
        border-radius: 4px;
        white-space: nowrap;

        opacity: 0;
        animation: fadeInOut 4s forwards;
        pointer-events: none;
    }

    @keyframes fadeInOut {
        0% {
            opacity: 0;
        }
        10% {
            opacity: 1;
        }
        80% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

    @media (min-width: 576px) {
    }

    @media (min-width: 768px) {
    }

    @media (min-width: 992px) {
        .menu_all {
            position: relative;
            /*if not responsive*/
            float: right;
        }
        :global(.gallery_2_wrapper) {
            margin-right: 0px;
        }

        h1 {
            font-size: 4em;
            font-weight: 100;
        }
    }

    @media (min-width: 1200px) {
    }

    @media (min-width: 1400px) {
    }
</style>
